// extracted by mini-css-extract-plugin
module.exports = {"subtable":"AssociationList_subtable__hc4YO","detailTable":"AssociationList_detailTable__1N2uy"};